import { useEffect } from "react";
import { Form, Input, Flex, Button, Alert } from "antd";
import { useForm } from "antd/es/form/Form";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import BankListSelect from "./getbacklist";
import AmountField from "../../components/AmountField";
import { formatPayoutAmount } from "../../utils/payoutDisplay";

const PayoutRequestForm = ({
  maxAmount,
  loading,
  onSubmit,
  onBack,
}: {
  maxAmount: number;
  loading: boolean;
  onSubmit: (values: {
    amount: string;
    bank_account_id: string;
    organizer_note?: string;
  }) => void;
  onBack?: () => void;
}) => {
  const [form] = useForm();
  const { data: bankData } = useSelector((state: RootState) => state.banklist);
  const bankList = bankData?.data?.data ?? [];

  useEffect(() => {
    if (maxAmount > 0) {
      form.setFieldValue("amount", String(maxAmount));
    }
  }, [maxAmount, form]);

  useEffect(() => {
    if (bankList.length === 1) {
      form.setFieldValue("bank_account_id", bankList[0].id);
    }
  }, [bankList, form]);

  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={onSubmit}
    >
      <Alert
        type="info"
        showIcon
        className="!mb-[16px]"
        message={
          <span>
            Available payout:{" "}
            <strong>{formatPayoutAmount("INR", maxAmount)}</strong>
          </span>
        }
      />

      <AmountField name="amount" currency="INR" maxAmount={maxAmount} />

      <BankListSelect />

      <Form.Item label="Remark" name="organizer_note">
        <Input.TextArea rows={3} />
      </Form.Item>

      <Flex justify="space-between" align="center">
        <div>
          {onBack && (
            <Button onClick={onBack} disabled={loading}>
              Back
            </Button>
          )}
        </div>
        <Button
          type="primary"
          htmlType="submit"
          loading={loading}
          disabled={maxAmount <= 0}
        >
          Submit Request
        </Button>
      </Flex>
    </Form>
  );
};

export default PayoutRequestForm;
